import React, { SyntheticEvent, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import auth from "../services/auth";
import { toast } from "react-toastify";
import { user } from "../common/type";
import { useNavigate } from "react-router-dom";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";

const Login = (props: {setUser: (user: user) => void; user: user | null}) => {
  const [emailorPhone, setEmailorPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser, user } = props
  const navigate = useNavigate()
  const [isVisible, setIsVisible] = useState(false)

  const onSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();
    setLoading(true);

    const wait = toast.loading("Logging in...", { theme: "colored" });

    try {
      await auth.login(emailorPhone, password);
      const res = await auth.getUser();
      setUser(res.data);

      toast.update(wait, {
        render: "Login Successful",
        type: "success",
        autoClose: 2500,
        isLoading: false,
        closeOnClick: true
      });

      navigate('/')
    } catch (err: any) {
      if(err.code === "ERR_NETWORK")
        toast.update(wait, {
          render: err?.message,
          type: "error",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true
        });
      else
        toast.update(wait, {
          render: err?.response?.data || "Invalid credentials",
          type: "error",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true
        });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(user)
      navigate('/')
  }, [navigate, user])

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>

      {/* ===== Inline CSS ===== */}
      <style>{`
        body {
          background: linear-gradient(135deg, #b4c6fc, #588be4);
        }

        .login-wrapper {
          min-height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .login-card {
          background: #ffffff;
          width: 380px;
          padding: 2.5rem;
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          animation: fadeIn 0.8s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .login-title {
          text-align: center;
          font-size: 1.6rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #1e3c72;
        }

        .form-group {
          margin-bottom: 1.2rem;
        }

        .form-group label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #444;
          display: block;
          margin-bottom: 0.4rem;
        }

        .form-group input {
          width: 100%;
          padding: 0.7rem;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 0.9rem;
          transition: all 0.3s;
        }

        .form-group input:focus {
          border-color: #2a5298;
          box-shadow: 0 0 0 2px rgba(42,82,152,0.2);
          outline: none;
        }

        .login-btn {
          width: 100%;
          padding: 0.75rem;
          border-radius: 10px;
          border: none;
          background: linear-gradient(135deg, rgb(82, 100, 133), #5d84c7);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .login-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(30,60,114,0.4);
        }

        .login-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .footer-text {
          margin-top: 1rem;
          text-align: center;
          font-size: 0.8rem;
          color: #777;
        }
      `}</style>

      {/* ===== UI ===== */}
      <div className="login-wrapper">
        <form className="login-card" onSubmit={onSubmit}>
          <div className="login-title">Welcome</div>

          <div className="form-group">
            <label>Email or Phone</label>
            <input
              type="text"
              placeholder="Enter email or phone"
              required
              value={emailorPhone}
              onChange={(e) => setEmailorPhone(e.target.value)}
            />
          </div>


          <div className="form-group">
            <label>Password</label>
            <div className="inline flex w-full items-center relative">
              <input
                type={isVisible ? "text" : "password"}
                placeholder="********"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {
                isVisible
                  ?
                  <VisibilityOffOutlined className="absolute right-3 cursor-pointer" onClick={() => setIsVisible(false)} />
                  :
                  <VisibilityOutlined className="absolute right-3 cursor-pointer" onClick={() => setIsVisible(true)} />
              }
            </div>
          </div>

          <button className="login-btn" disabled={loading}>
            Login
          </button>

          <div className="footer-text">
            Secure Dental Clinic SAAS Management System
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;